import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {ObservableBackendService} from './observableBackend.service';
import {VehicleBrand} from '../domain/vehicleBrand';
import {ActionAllowed} from '../domain/actionAllowed';
import {URLSearchParams} from "@angular/http";
import {Page} from "../domain/page";
@Injectable()
export class VehicleBrandService {

    constructor(private backendService:ObservableBackendService) {
    }

    public findVehicleBrands(filter:string, page:number, itemsPerPage:number):Observable<Page> {
        let params = new URLSearchParams();
        if (filter) {
            params.set('name', filter);
        }

        params.set('length', String(itemsPerPage));
        params.set('pageNumber', String(page));
        return this.backendService.get("vehicleBrands", params);
    }

    public getVehicleBrand(vehicleBrandId:string):Observable<VehicleBrand> {
        return this.backendService.get("vehicleBrand/" + vehicleBrandId, null);
    }

    public getNewVehicleBrand():Observable<VehicleBrand> {
        return this.backendService.get("vehicleBrand/new", null);
    }

    public getVehicleBrands():Observable<VehicleBrand[]> {
        return this.backendService.get("listVehicleBrands/", null);
    }

    public save(vehicleBrand:VehicleBrand):Observable<VehicleBrand> {
        return vehicleBrand.id != null
            ? this.backendService.post("vehicleBrand", vehicleBrand, null)
            : this.backendService.put("vehicleBrand", vehicleBrand, null);
    }

    public delete(vehicleBrandId:string):Observable<VehicleBrand> {
        return this.backendService.delete("vehicleBrand/" + vehicleBrandId, null, null);
    }
}


/** WEBPACK FOOTER **
 ** ./src/app/service/vehicleBrand.service.ts
 **/